import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StepService {

  public cantinaDenominazione: string;
  public richiediDatiFiscaliRicevuta: boolean;

  public currentStep: number;

  public admPagaCantina = false;
  public admPagaCantinaSC = false;
  public supplementoSC = 0;
  public supplementoAttivo = false;
  public pagaCantinaInsite = false;

  public currentVisita: any;

  private carrello: any;
  private cliente: {};


  constructor() { }

  setCarrello(carrello) {
    this.carrello = carrello;
  }

  setCliente(cliente) {
    this.cliente = cliente;
  }

  getCarrello() {
    return this.carrello;
  }

  getTotale(): number {
    if (this.carrello) {
      if (this.carrello.promo === '') {
        return this.carrello.totale;
      } else {
        return this.carrello.totalescontato;
      }
    } else {
      return 0;
    }
  }
}
